
  import { mapState, mapMutations } from 'vuex'
  import { removeMeta, useMemo } from '~/utils/tools.js'
  const [memoWidth, memoPage, memoScroll] = [useMemo(), useMemo(), useMemo()]
  export default {
    name: 'LibTemplate',
    components: {
      NewLibSearch: () => import('~/components/library-center/new-lib-search.vue'),
      LibComposePreview: () => import('~/components/library-center/lib-compose-preview.vue'),
    },
    data() {
      return {
        dialogConf: {
          show: false,
          qrcode: '',
          active: '',
        },
        searchType: 2,
        setConf: null,
        showSearch: false,
        isInit: true,
      }
    },
    head: {
      title: '问卷满意度调查分析报告-市场调研表格模板-问卷网',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '问卷,调查模板,问卷模板,问卷调查,调查问卷,调查分析报告,问卷调查表,满意度调查,市场调查问卷',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '问卷网(www.wenjuan.com)拥有内容丰富的问卷模板库，由专业研究员设计和会员共享的海量市场调查问卷模板、调查问卷格式，让你轻松制作各类调查问卷、调研分析报告，进行问卷调查表设计等',
        },
      ],
    },
    computed: {
      ...mapState(['loginStatus', 'headerActive', 'mediaType', 'hostname']),
    },

    mounted() {
      this.setHightLightHeader({
        active: 'lib',
      })
      removeMeta('applicable-device')
      this.$watch('$store.state.innerWidth', (cval) => this.proxyClientWidth(cval), { immediate: true })
    },
    methods: {
      ...mapMutations(['setHightLightHeader']),
      proxyClientWidth(width) {
        const critical = width > 1280
        memoWidth(critical, () => {
          this.setConf = ({ list }) => {
            return this.showSearch ? list.slice(0, critical ? list.length : -2) : list
          }
        })
        const type = width > 1150 ? 2 : 3
        memoPage(type, () => (this.searchType = type))
      },
      scroll(top) {
        memoScroll(top > 310, () => {
          this.showSearch = top > 310
          if (this.isInit && this.showSearch) this.isInit = false
        })
      },
    },
  }
